import FDictionary from '../__select';

export default class FDictionaryService extends FDictionary {
  dictionary = 'serviceClass';
}
